import type { PagyInterface, ReactProps } from '@interfaces/index'

export interface OrderListProps extends ReactProps {
  data: {
    orders:
      | {
          edges: { cursor: string | null; node: OrderInterface }[]
          page_info: {
            has_next_page: boolean
            has_previous_page: boolean
          }
        }
      | { orders: NewOrderInterface[]; pagy: PagyInterface }
  }
  themes_defaul: Array<number>
}
export interface OrdersQueryInterface {
  orders: {
    edges: {
      cursor: string
      node: OrderInterface
    }[]
    page_info: {
      has_next_page?: boolean
      has_previous_page?: boolean
    }
  }
}

export interface OrderInterface {
  id?: string
  name?: string
  /** Số đơn Shopify gốc (vd. #1001). */
  shopify_order_name?: string
  /** Số hóa đơn Fordeer (custom invoice). */
  invoice_name?: string
  created_at?: Date
  customer?: {
    display_name?: string
  }
  status?: string
  current_total_price_set?: {
    shop_money?: {
      amount?: number
    }
  }
  current_total_tax_set?: {
    shop_money?: {
      amount?: number
    }
  }
  current_subtotal_line_items_quantity?: number
  subtotal_line_items_quantity?: number
  currency_code?: string
  display_financial_status?: string
  display_fulfillment_status?: string
  shipping_line?: {
    title?: string
  }
  /** FOR-463: invoice đã được merchant manual edit + lưu. */
  manually_edited?: boolean
}

export interface NewOrderInterface {
  id?: string
  name: string
  /** Số đơn Shopify gốc (vd. #1001). */
  shopify_order_name?: string
  /** Số hóa đơn Fordeer (custom invoice). */
  invoice_name?: string
  customer_name: string
  total_price: string
  current_total_tax_set?: {
    shop_money?: {
      amount?: number | string
    }
  }
  current_subtotal_line_items_quantity?: number
  subtotal_line_items_quantity?: number
  display_financial_status?: string
  display_fulfillment_status: string
  shipping_line?: {
    title?: string
  }
  currency_code: string
  shopify_order_created: string
  shopify_order_id: string
  /** FOR-463: invoice đã được merchant manual edit + lưu. */
  manually_edited?: boolean
}

export interface OrderLazyPropsInterface<T> extends ReactProps {
  data?: T
  pageParams?: unknown[]
  fetchNextPage?(args?: Record<string, never>): void
  fetchPreviousPage?(args?: Record<string, never>): void
  isLoading: boolean
  isFetching?: boolean
  isFetchingPreviousPage?: boolean
  isFetchingNextPage?: boolean
}
export interface OrderPrintInterface {
  item: OrderInterface
  outputs?: string[]
  themes?: A[]
}

export interface Ipdf {
  pdf_padding_top: '0'
  pdf_padding_right: '0'
  pdf_padding_bottom: '0'
  pdf_padding_left: '0'
}

export const OrderTypeOptions = {
  Invoice: 'invoice',
  PackingSlip: 'packing_slip',
  Refund: 'refund',
  Order: 'order',
} as const

export type TOrderTypeOptions =
  (typeof OrderTypeOptions)[keyof typeof OrderTypeOptions]
